import {Component, Input} from '@angular/core';
import {ITaxClass} from "../add-product-form.interface";
import {IDsDropdownOption} from "../../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'db-product-tax',
    templateUrl: './product-tax.component.html',
    styleUrl: './product-tax.component.scss',
    standalone: false
})
export class ProductTaxComponent {
  taxDropdown: IDsDropdownOption[];
  @Input() taxClassForm: FormGroup;

  @Input() set taxList(list: ITaxClass[]) {
    this.taxDropdown = list.map(tax => {
      return {
        value: tax.slug,
        label: tax.name
      };
    });
  }

  onOptionSelect(value: IDsDropdownOption) {
    this.taxClassForm.setValue({
      slug: value.value,
      name: value.label
    });
    this.taxClassForm.markAsDirty();
  }
}
